// extracted by mini-css-extract-plugin
export default {"container":"Np-z","heading":"Op-z","text":"Pp-z","info":"Qp-z","link":"Rp-z","fullMaxWidth":"Sp-z"};